import React from 'react';
import PropTypes from 'prop-types';

// Import Local Styles
import styles from './centering.css';

const Centering = (props) => {
    const { children, relative, style, modifier, lessBottomMargin } = props;

    return (
        <div className={`${styles.centering} ${lessBottomMargin ? styles['centering--less-bottom-margin'] : ''}  ${relative ? styles.relative : ''}  ${modifier || ''}`} style={ style }>
            {children}
        </div>
    );
};

Centering.propTypes = {
    children: PropTypes.node,
    style: PropTypes.object,
    relative: PropTypes.bool,
    modifier: PropTypes.string
};

export default Centering;
